export enum PageName {
  WorkspaceSetting = 'Workspace Setting'
}
